import {Fragment} from 'react';
import {Button} from '@ezcater/tapas';
import useTranslation from 'next-translate/useTranslation';

import {useRedirect} from '@/components/global/providers/RedirectionProvider';
import useTracking from '@/hooks/useTracking';
import {PRIVACY_PATH} from '@/paths';
import {compilePath} from '@/utils';

type TranscendButtonProps = {
  as?: 'li' | 'span';
  className?: string;
};

const TranscendButton: React.FC<TranscendButtonProps> = ({as: Tag = 'span', className}) => {
  const {t} = useTranslation('common');
  const tracker = useTracking();
  const redirect = useRedirect();

  return (
    <Fragment key={'doNotSellMyInfo'}>
      <Tag>
        <Button
          className={className}
          onClick={() => {
            tracker.trackClick('footer-transcend-modal');
            if ((window as any).transcend) {
              (window as any).transcend.showConsentManager({viewState: 'DoNotSellExplainer'});
            } else {
              redirect(compilePath(PRIVACY_PATH));
            }
          }}
          variant="buttonLink"
        >
          {t(`components.Footer.pathNames.doNotSellMyInfo`)}
        </Button>
      </Tag>
    </Fragment>
  );
};

export default TranscendButton;
